import type { MarketingPageContent } from './types';

export const AI_VIDEO_CONTINUITY_CONTENT: MarketingPageContent = {
  title: 'AI Video Continuity with Induce',
  headerLabel: 'Use Case',
  lede:
    'Your protagonist looks like your protagonist in every scene. Induce keeps characters, wardrobe, locations, and mood persistent across the entire timeline.',
  sections: [
    {
      id: 'memory-graph',
      title: 'Persistent agentic memory',
      body: 'Your protagonist looks like your protagonist in every scene. Characters, wardrobe, locations, and mood persist across the entire timeline.',
    },
    {
      id: 'downstream',
      title: 'Continuity across scenes',
      body: "Every character, location, wardrobe, prop, and mood lives in a persistent memory graph that the whole timeline reads from. Make a change on page one and the cut updates downstream. it doesn't re-roll every shot from scratch.",
    },
    {
      id: 'local-overrides',
      title: 'Local shot overrides',
      body: 'Override any shot, angle, lighting, pacing, performance - without disturbing the surrounding cut. Overrides read as notes to the system, not full re-prompts.',
    },
  ],
};
